/**
 * RegistroCompra Entity
 * Modelos y tipos puros sin lógica
 */

export * from './constants';
